module.exports = __webpack_public_path__ + "img/OGG_Background_LightBlue.a4505255.png";